<template>
  <div class="chat-page">
    <ChatContainer :conversationId="conversationId" />
  </div>
</template>

<script>
import ChatContainer from '@/components/ChatContainer.vue'

export default {
  name: 'ChatPage',
  components: {
    ChatContainer
  },
  props: {
    conversationId: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.chat-page {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
</style>